import BcaIcon from '@/assets/icon/BCA.svg';
import BcaDigitalIcon from '@/assets/icon/BCA Digital.svg';
import BniIcon from '@/assets/icon/BNI.svg';
import BriIcon from '@/assets/icon/BRI.svg';
import BsiIcon from '@/assets/icon/BSI.svg';
import CimbIcon from '@/assets/icon/CIMB.svg';
import DanaIcon from '@/assets/icon/DANA.svg';
import GopayIcon from '@/assets/icon/GoPay.svg';
import LinkAjaIcon from '@/assets/icon/LinkAja.svg';
import MandiriIcon from '@/assets/icon/Mandiri.svg';
import MaybankIcon from '@/assets/icon/Maybank.svg';
import OvoIcon from '@/assets/icon/OVO.svg';
import PermataIcon from '@/assets/icon/Permata.svg';
import ShopeePayIcon from '@/assets/icon/Spay.svg';

// Logos by DOKU bank code (GET /banks)
const BANK_ICONS: Record<string, string> = {
  '002': BriIcon,
  '008': MandiriIcon,
  '009': BniIcon,
  '013': PermataIcon,
  '014': BcaIcon,
  '016': MaybankIcon,
  '022': CimbIcon,
  '451': BsiIcon,
  '501': BcaDigitalIcon,
  GOPAY: GopayIcon,
  DANA: DanaIcon,
  SHOPEEPAY: ShopeePayIcon,
  OVO: OvoIcon,
  '911': LinkAjaIcon,
};

/** Logo of a bank by its code; undefined for any other bank (the card then shows its initials). */
export const bankIcon = (code: string | undefined) => (code ? BANK_ICONS[code] : undefined);
